import { Tag } from 'antd';
import React from 'react';

const PlatformType = {
  ZMP3: [1, 'ZingMP3', <Tag color={'#BF6AD9'}>Zing MP3</Tag>],
  ORCHARD: [2, 'Orchard', <Tag color={'#FF5B3A'}>Orchard</Tag>],
};

export default PlatformType;
